module.exports = __webpack_public_path__ + "static/media/One-Does-Not-Simply.7ce99a76.jpg";